import { LIMPAR_FILTRO_PEDIDO } from '../types'

export default function limparFiltroPedido () {
  return {
    type: LIMPAR_FILTRO_PEDIDO
  }
}
